module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalClasses = []\nconst additionalAttributes = []\nconst headline = config.headline || {}\nheadline.contentKey = headline.contentKey || config.headlineKey\nconst pricesSetByJobIDs = model.pricesSetByJobIDs || {}\nconst markers = model.jobPriceMarkers = {}\nconst isCardDisplayMode = config.displayMode === 'cards'\nconst isListDisplayMode = config.displayMode === 'list'\nif(config.displayMode){\nadditionalClasses.push(`displayMode_${config.displayMode}`)\n}\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n%><div <%- additionalAttributes.join(' ') %>><%\nif(headline.contentKey){\n%><%- include('../../../../base/form/elements/static_headline', { formMapping: headline, }) %><%\n}\n%><div class=\"list\"><%\nif(utils.collectionSize(model.entities) < 1){\n%><p class=\"empty\"><%= storage.__('form.fields.selectEmployeeJobs.emptyJobList') %></p><%\n} else {\nlet field, entity, entityKey, jobID, attributes;\n// let buttonsClasses\nfor(entityKey in model.entities){\nentity = model.entities[entityKey] || {}\nattributes = entity.attributes || {}\njobID = attributes.jobID\nfield = entity.field || {}\n%><div class=\"entry\" data-job-id=\"<%= jobID %>\"><%\nif(isListDisplayMode){\n%><div class=\"code\"><%= attributes.code || '-' %></div><%\nif(config.showJobDescriptions && attributes.description){\n%><%- include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) %><%\n}\n%><%- include('../../../../base/form/elements/label', { model: { label: entity.title }}) %><%\n%><div class=\"content\"><%\n%><%- include('../../../../base/form/fields/nrOfElements', { model: { dataINT: field.value, fieldCode: field.fieldCode, atom: { dataType: 'integer' }, config: { style: 'oneLine', } }}) %><%\n%></div><%\n} else if(isCardDisplayMode){\n%><%- include('../../../../base/form/elements/label', { model: { label: entity.title }}) %><%\nif(config.showJobDescriptions && attributes.description){\n%><%- include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) %><%\n}\n%><div class=\"content\"><%\n%><%- include('../../../../base/form/fields/nrOfElements', { model: { dataINT: field.value, fieldCode: field.fieldCode, atom: { dataType: 'integer' }, config: { iconText: attributes.code, } }}) %><%\n%></div><%\n}\n%></div><%\n}\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/core/form/fields/selectNrOfElementsPerJob.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalClasses = []
const additionalAttributes = []
const headline = config.headline || {}
headline.contentKey = headline.contentKey || config.headlineKey
const pricesSetByJobIDs = model.pricesSetByJobIDs || {}
const markers = model.jobPriceMarkers = {}
const isCardDisplayMode = config.displayMode === 'cards'
const isListDisplayMode = config.displayMode === 'list'
if(config.displayMode){
additionalClasses.push(`displayMode_${config.displayMode}`)
}
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)

    ; __line = 14
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 
if(headline.contentKey){

    ; __line = 16
    ; __append( include('../../../../base/form/elements/static_headline', { formMapping: headline, }) )
    ; 
}

    ; __line = 18
    ; __append("<div class=\"list\">")
    ; 
if(utils.collectionSize(model.entities) < 1){

    ; __line = 20
    ; __append("<p class=\"empty\">")
    ; __append(escapeFn( storage.__('form.fields.selectEmployeeJobs.emptyJobList') ))
    ; __append("</p>")
    ; 
} else {
let field, entity, entityKey, jobID, attributes;
// let buttonsClasses
for(entityKey in model.entities){
entity = model.entities[entityKey] || {}
attributes = entity.attributes || {}
jobID = attributes.jobID
field = entity.field || {}

    ; __line = 29
    ; __append("<div class=\"entry\" data-job-id=\"")
    ; __append(escapeFn( jobID ))
    ; __append("\">")
    ; 
if(isListDisplayMode){

    ; __line = 31
    ; __append("<div class=\"code\">")
    ; __append(escapeFn( attributes.code || '-' ))
    ; __append("</div>")
    ; 
if(config.showJobDescriptions && attributes.description){

    ; __line = 33
    ; __append( include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) )
    ; 
}

    ; __line = 35
    ; __append( include('../../../../base/form/elements/label', { model: { label: entity.title }}) )
    ; 

    ; __line = 36
    ; __append("<div class=\"content\">")
    ; 

    ; __line = 37
    ; __append( include('../../../../base/form/fields/nrOfElements', { model: { dataINT: field.value, fieldCode: field.fieldCode, atom: { dataType: 'integer' }, config: { style: 'oneLine', } }}) )
    ; 

    ; __line = 38
    ; __append("</div>")
    ; 
} else if(isCardDisplayMode){

    ; __line = 40
    ; __append( include('../../../../base/form/elements/label', { model: { label: entity.title }}) )
    ; 
if(config.showJobDescriptions && attributes.description){

    ; __line = 42
    ; __append( include('../../../../base/tooltip/tooltip', { model: { title: attributes.title, message: attributes.description }, config: { orientation: 'SE-NE', autoCorrectScrollOffset: true } }) )
    ; 
}

    ; __line = 44
    ; __append("<div class=\"content\">")
    ; 

    ; __line = 45
    ; __append( include('../../../../base/form/fields/nrOfElements', { model: { dataINT: field.value, fieldCode: field.fieldCode, atom: { dataType: 'integer' }, config: { iconText: attributes.code, } }}) )
    ; 

    ; __line = 46
    ; __append("</div>")
    ; 
}

    ; __line = 48
    ; __append("</div>")
    ; 
}
}

    ; __line = 51
    ; __append("</div>")
    ; 

    ; __line = 52
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/selectNrOfElementsPerJob.ejs

}